import React from 'react';
import {
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from '../components/LanguageToggle';
import ThemeToggle from '../components/ThemeToggle';
import UserMenu from '../components/UserMenu';

interface QuickLink {
  label: string;
  description: string;
  href: string;
}

const More: React.FC = () => {
  const { t } = useLanguage();

  const links: QuickLink[] = [
    { label: t('materials'), description: t('manageMaterials') ?? t('materials'), href: '/tabs/materials' },
    { label: t('manufacturing'), description: t('manageManufacturing') ?? t('manufacturing'), href: '/tabs/manufacturing' },
    { label: t('recipes'), description: t('viewRecipes') ?? t('recipes'), href: '/tabs/recipes' },
    { label: t('inventory'), description: t('inventoryOverview') ?? t('inventory'), href: '/tabs/inventory' },
    { label: t('warehouses'), description: t('manageWarehouses') ?? t('warehouses'), href: '/tabs/warehouses' },
    { label: t('assets'), description: t('manageAssets') ?? t('assets'), href: '/tabs/assets' },
    { label: t('categories'), description: t('manageCategories') ?? t('categories'), href: '/tabs/categories' },
    { label: t('categoryTags') || 'Category Tags', description: t('manageCategoryTags') || 'Manage category tags and colors', href: '/tabs/category-tags' },
    { label: t('actionLogs') || 'Action Logs', description: t('viewActionLogs') || 'View system activity and audit trail', href: '/tabs/action-logs' },
    { label: t('menuManagement') ?? 'Menu management', description: t('manageMenu') ?? 'Menu management', href: '/tabs/menu' },
    { label: t('users'), description: t('manageUsers') ?? t('users'), href: '/tabs/users' },
    { label: t('customers'), description: t('manageCustomers') ?? t('customers'), href: '/tabs/customers' },
  ];

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar>
          <IonTitle>{t('more') ?? 'More'}</IonTitle>
          <LanguageToggle />
          <UserMenu />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <div style={{ paddingTop: 'var(--ion-safe-area-top)' }}>
          <IonText color="primary">
            <h2 style={{ marginBottom: 12 }}>{t('quickLinks') ?? 'Quick links'}</h2>
          </IonText>
          <IonList>
            {links.map((link) => (
              <IonItem key={link.href} routerLink={link.href} detail>
                <IonLabel>
                  <h3>{link.label}</h3>
                  <p>{link.description}</p>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>

          <IonText color="primary" style={{ marginTop: '24px' }}>
            <h2 style={{ marginBottom: 12 }}>{t('settings') || 'Settings'}</h2>
          </IonText>
          <IonList>
            <ThemeToggle variant="select" />
            <LanguageToggle />
          </IonList>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default More;
